"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateTimePattern = void 0;
exports.dateTimePattern = '^(\\d{4}-\\d{2}-\\d{2}) (\\d{2}):(\\d{2}):(\\d{2})(.)(\\d{1,6})$';
